import { useCallback } from 'react';

/**
 * Custom hook for date formatting utilities
 * Provides memoized date formatting functions for Italian locale
 */
export const useDateFormatter = () => {
  const formatDate = useCallback((input: string | Date): string => {
    const date = input instanceof Date ? input : new Date(input);
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }, []);

  const formatDateTime = useCallback((input: string | Date): string => {
    const date = input instanceof Date ? input : new Date(input);
    return date.toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }, []);

  const formatTime = useCallback((input: string | Date): string => {
    const date = input instanceof Date ? input : new Date(input);
    return date.toLocaleTimeString('it-IT', {
      hour: '2-digit',
      minute: '2-digit',
    });
  }, []);

  const formatLongDate = useCallback((date: Date): string => {
    return date.toLocaleDateString('it-IT', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }, []);

  return {
    formatDate,
    formatDateTime,
    formatTime,
    formatLongDate,
  };
};
